let initState = {getParamsTariff: {}};

export function sendParamsStore(state = initState, action) {
    switch (action.type) {
        case "SET_TARIFF_PARAMS":
            return {...state, getParamsTariff: action};
    }
    return state;
}